// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import inquiryAddresseeEntity from './entities/inquiry-addressee.json';
import inquiryAddresseeMenu from '../pages/inquiry-addressee/menu.json';
import inquiryAddresseeFullForm from '../pages/inquiry-addressee/forms/full.json';
import inquiryAddresseeContextForm from '../pages/inquiry-addressee/forms/context.json';
import inquiryAddresseeMiniForm from '../pages/inquiry-addressee/forms/mini.json';
import inquiryAddresseeLookupForm from '../pages/inquiry-addressee/forms/lookup.json';
import inquiryAddresseeTableView from '../pages/inquiry-addressee/views/table.json';
import inquiryAddresseeCardsView from '../pages/inquiry-addressee/views/cards.json';
import inquiryAddresseeDashboardView from '../pages/inquiry-addressee/views/dashboard.json';

/** Тип запису «Адресат» зі сторінками пакета: меню, форми та подання з pages/inquiry-addressee/. */
export const inquiryAddresseeDefinition: IRecordTypeDefinition = {
  ...inquiryAddresseeEntity,
  views: assembleViewSet({
      table: inquiryAddresseeTableView,
      cards: inquiryAddresseeCardsView,
      dashboard: inquiryAddresseeDashboardView,
  }),
  form: inquiryAddresseeFullForm,
  forms: { full: inquiryAddresseeFullForm, context: inquiryAddresseeContextForm, mini: inquiryAddresseeMiniForm, lookup: inquiryAddresseeLookupForm },
  menu: inquiryAddresseeMenu,
} as IRecordTypeDefinition;
